/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import EventsTimeline from './EventsTimeline/index'
import FileUploader from 'DesignSystem/FileUploader/react'
import MessageTools from './MessageTools/index'
import React from 'react'
import Topbar from './Topbar/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content",
  restrictions,
  restrictionNote,
  onBeforeFileAdded,
  onChange
  
}) {
let messageComposeResetValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'reset',
})
let messageComposeIsUploadOpenValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'is_upload_open',
})
let messageComposeAttachmentsChangeData = fromData.useDataChange({ viewPath,
context: 'message_compose',
path: 'attachments',
})
let onClose = fromHelpers.useOnClose({
  children,
  viewPath,
  restrictions,
  restrictionNote,
  onBeforeFileAdded,
  onChange
  
})
  return (<React.Fragment
>
<FileUploader
  viewPath={`${viewPath}/FileUploader`}
 data="message_compose.reset"
 reset={messageComposeResetValueData}
 restrictions={restrictions}
 restrictionNote={restrictionNote}
 onBeforeFileAdded={onBeforeFileAdded}
 data="message_compose.is_upload_open"
 isOpen={messageComposeIsUploadOpenValueData}
 onClose={onClose}
 data="message_compose.attachments"
 onChange={messageComposeAttachmentsChangeData}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Topbar
  viewPath={`${viewPath}/Topbar`}
/>
<EventsTimeline
  viewPath={`${viewPath}/EventsTimeline`}
/>
<MessageTools
  viewPath={`${viewPath}/MessageTools`}
/>
</div>
)}
</FileUploader>
{children}
</React.Fragment>)
}